// extracted by mini-css-extract-plugin
export default {"infoValue":"TaskDetails_infoValue__QD79W","totalPoints":"TaskDetails_totalPoints__EZ3P+","taskContainer":"TaskDetails_taskContainer__blTQD"};